export enum LegalPath {
  ImprintPath = 'imprint',
  DataprivacyPath = 'data-privacy',
  TermsPath = 'terms-of-use',
  CookiePath = 'cookie-policy',
}

export const LegalRoute = 'legal';
